export default __webpack_public_path__ + "7ab25374ba29760ce7f34f7ec3018938.png";